import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import Inbox, { IInboxDispatchProps, IInboxProps } from './Inbox'
import { getUserNotificationsList, getUserNotificationsLoading, getFeedFilter } from './store/InboxSelectors'
import { getUserNotifications, setFeedFilter } from './store/InboxActions'

const mapStateToProps = (state: IGlobalState, ownProps: any): IInboxProps => ({
  notificationId: ownProps.match.params.notificationId || null,
  isPush: !!state.router.location.query.isPush,
  userNotifications: getUserNotificationsList(state),
  isLoading: getUserNotificationsLoading(state),
  feedFilter: getFeedFilter(state),
})

const mapDispatchToProps: IInboxDispatchProps = {
  getUserNotifications,
  setFeedFilter,
}

export default connect(mapStateToProps, mapDispatchToProps)(Inbox)
